export default "__VITE_ASSET__6517b75e__"